/** Zone cliquable sur l’image Poinçon (repas), en % de la largeur / hauteur affichée. */
export const POINCON_QUEST_HOTSPOT = {
  top: 13,
  left: 54,
  width: 3,
  height: 4.5,
} as const;
